import { CheckCircle2, Send, XCircle } from 'lucide-react';
import type { SlotComponentProps } from '../../types';

const TransactionalExecutionBlock = ({ classification, emitSignal }: SlotComponentProps) => {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-violet-100 text-violet-700">
          <Send className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Execution-first layout</h2>
          <p className="text-sm text-slate-500">The engine pivoted to action because the user signaled readiness.</p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <label className="rounded-2xl border border-slate-200 p-4 text-sm text-slate-700">
          <span className="mb-2 block font-semibold text-slate-900">Action label</span>
          <input
            defaultValue="Start application"
            className="w-full rounded-xl border border-slate-300 px-3 py-2 outline-none focus:border-violet-500"
          />
        </label>
        <label className="rounded-2xl border border-slate-200 p-4 text-sm text-slate-700">
          <span className="mb-2 block font-semibold text-slate-900">Risk check</span>
          <select className="w-full rounded-xl border border-slate-300 px-3 py-2 outline-none focus:border-violet-500">
            <option>Ready to submit</option>
            <option>Need review</option>
          </select>
        </label>
      </div>

      <div className="mt-5 flex flex-wrap gap-3">
        <button
          onClick={() =>
            emitSignal({
              type: 'submit',
              timestamp: Date.now(),
              metadata: { intent: classification.intent, surface: 'transactional-block' },
            })
          }
          className="inline-flex items-center gap-2 rounded-2xl bg-violet-600 px-4 py-3 text-sm font-semibold text-white hover:bg-violet-700"
        >
          <CheckCircle2 className="h-4 w-4" />
          Execute action
        </button>

        <button
          onClick={() =>
            emitSignal({
              type: 'cancel',
              timestamp: Date.now(),
              metadata: { surface: 'transactional-block' },
            })
          }
          className="inline-flex items-center gap-2 rounded-2xl border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          <XCircle className="h-4 w-4" />
          Cancel
        </button>
      </div>
    </div>
  );
};

export default TransactionalExecutionBlock;